export interface RoleModel {
  id?: string;
  name?: string;
}

export function roleModelFactory(json?: any): RoleModel {
  json = json || {};

  return {
    id: json.id || "",
    name: json.name || "",
  } as RoleModel;
}

export function roleModelListFactory(json?: any): RoleModel[] {
  return Array.from(json || []).map(row => roleModelFactory(row)) as RoleModel[];
}
